export const initialState = { dataWeather: {}, dataForecast: {} };
